import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { loginAD } from "../../apis";
import { startFinalLogin } from '../../store/auth/authThunks';
import { useDispatch } from 'react-redux';

const AuthCallback = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');

        if (!code) {
          throw new Error('No se recibió código de autorización');
        } else {

          const result = await loginAD(code);

          if (result && result.data) {
            // El correo viene en la respuesta del canje. Antes se guardaba la
            // cadena "not-given", y varias pantallas leen Session.email para
            // saber quién es el usuario (perfil, testigos, usuarios del reporte).
            dispatch(startFinalLogin(result.data.email ?? "", result));
            navigate('/');
          } else {
            // Si no hay datos, considerarlo como un error
            throw new Error('No se recibieron datos de autenticación');
          }

        }
      } catch (error) {
        console.error("Error durante la autenticación:", error);
        // Redirigir al usuario a la página de login en caso de cualquier error
        navigate('/');
      }
    };

    handleCallback();
  }, [location, navigate, dispatch]);

  return <div>working...</div>;
};

export default AuthCallback;
